import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/userGroupActions";
import * as api from "../../api/userGroupApi";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";

function* getUserGroups(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getUserGroups(action.payload);
        yield put(actions.setUserGroups(data || undefined));
    } catch (error) {
        yield put(actions.setUserGroups(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* addUserGroup(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.addUserGroup(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* updateUserGroup(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.updateUserGroup(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deleteUserGroup(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.deleteUserGroup(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPlants() {
    try {
        const { data } = yield api.getPlants();
        yield put(actions.setPlants(data || undefined));
    } catch (error) {
        yield put(actions.setPlants(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getUserGroupByID(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getUserGroupbyid(action.payload);
        yield put(actions.setUserGroupbyID(data || undefined));
    } catch (error) {
        yield put(actions.setUserGroupbyID(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPoolList(action) {
    try {
        const { data } = yield api.getPoolList(action.payload);
        yield put(actions.setPoolList(data || undefined));
    } catch (error) {
        yield put(actions.setPoolList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* updateUserPoolGroup(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.updatePoolofUserGroup(action.payload);
        yield put(actions.setPoolUserGroup(data || undefined));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(actions.setPoolUserGroup(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_USER_GROUPS, getUserGroups);
    yield takeEvery(actions.Types.ADD_USER_GROUP, addUserGroup);
    yield takeEvery(actions.Types.UPDATE_USER_GROUP, updateUserGroup);
    yield takeEvery(actions.Types.DELETE_USER_GROUP, deleteUserGroup);
    yield takeEvery(actions.Types.GET_PLANTS, getPlants);
    yield takeEvery(actions.Types.GET_USER_GROUP_BY_ID, getUserGroupByID);
    yield takeEvery(actions.Types.GET_POOL_LIST, getPoolList);
    yield takeEvery(actions.Types.UPDATE_POOL_USER_GROUP, updateUserPoolGroup);
}

const UserGroupSagas = [fork(watchAll)];

export default UserGroupSagas;
